import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ListarRenegociacaoAnaliseController } from "../../../Controllers/Cobranca/AprovacaoRenegociacoes/AprovacaoRenegociacoesController";
import Table from "../../../Components/Table";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IFiltroRenegociacaoAnalise,
    IRenegociacoesAnalise,
} from "../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { faEye, faMoneyCheckAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RenegociacaoModal from "./RenegociacaoModal";
import FiltroAprovacaoRenegociacao from "./FiltroAprovacaoRenegociacao";

export default function AprovacaoRenegociacao() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const filtroInicial = {
        DT_APROVACAO_INICIO: "",
        DT_APROVACAO_FIM: "",
        ID_USUARIO_RESPONSAVEL: 0,
        DS_STATUS: "",
    };

    const FILTRO_GESTAO_APROVACAO_RENEGOCIACAO = sessionStorage.getItem(
        "FILTRO_GESTAO_APROVACAO_RENEGOCIACAO"
    );

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<IFiltroRenegociacaoAnalise>({
            page: 1,
            filter: FILTRO_GESTAO_APROVACAO_RENEGOCIACAO
                ? JSON.parse(FILTRO_GESTAO_APROVACAO_RENEGOCIACAO)
                : filtroInicial,
        });

    const handleDateChange = (formData: IFiltroRenegociacaoAnalise) => {
        const filterFormData = {
            ...formData,
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_GESTAO_A_NEGATIVAR",
            JSON.stringify(filterFormData)
        );
    };

    const {
        value: lstRenegociacoes,
        loading: lstRenegociacoesLoading,
        execute: lstRenegociacoesExecute,
    } = useAsyncEffect(async () => {
        return ListarRenegociacaoAnaliseController(PageFilter.page, {
            DS_STATUS: filter?.DS_STATUS ? filter?.DS_STATUS : "",
            DT_APROVACAO_FIM: filter?.DT_APROVACAO_FIM
                ? filter?.DT_APROVACAO_FIM
                : "",
            DT_APROVACAO_INICIO: filter?.DT_APROVACAO_INICIO
                ? filter?.DT_APROVACAO_INICIO
                : "",
            ID_USUARIO_RESPONSAVEL: filter?.ID_USUARIO_RESPONSAVEL
                ? filter?.ID_USUARIO_RESPONSAVEL
                : 0,
        });
    }, [PageFilter, filter]);

    const totalPaginas = lstRenegociacoes
        ? lstRenegociacoes[0]?.NR_PAGINAS || 1
        : 1;

    const tableViewColumns: Array<ColumnDescription<IRenegociacoesAnalise>> = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="historico-tooltip">
                            {row.DS_STATUS === "AGUARDANDO APROVAÇÃO"
                                ? "Analisar a Renegociação"
                                : "Visualizar"}
                        </Tooltip>
                    }
                >
                    <button
                        className="btn btn-icon btn-outline-primary"
                        onClick={() => {
                            setModal({
                                Component: () => (
                                    <RenegociacaoModal
                                        updateList={lstRenegociacoesExecute}
                                        ID_CASO_COBRANCA_NEGOCIACAO_ANALISE={
                                            row.ID_CASO_COBRANCA_NEGOCIACAO_ANALISE
                                        }
                                        DS_STATUS={row.DS_STATUS}
                                        setShow={setShow}
                                        visualizarListagem={
                                            row.DS_STATUS ===
                                            "AGUARDANDO APROVAÇÃO"
                                                ? false
                                                : true
                                        }
                                    />
                                ),

                                headerComponent: "Renegociação",
                                IconHeader: faMoneyCheckAlt,
                                size: "xl",
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </button>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "ID_CASO",
            text: "Solicitação",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "ID_CASO",
            text: "Solicitação",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_NOME",
            text: "Cliente / Contato",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_NOME}</h5>
                </div>
            ),
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div style={{ color: CorDaAnalise(row), fontSize: 16 }}>
                        {row.DS_STATUS}
                    </div>
                </div>
            ),
        },

        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_USUARIO_RESPONSAVEL}</h5>
                    <span>{row.DS_EMPREENDIMENTO}</span>
                </div>
            ),
        },
        {
            dataField: "DS_PRODUTO",
            text: "Produto",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span>{row.DS_PRODUTO}</span>
                </div>
            ),
        },
        {
            dataField: "DT_PEDIDO_NEGOCIACAO",
            text: "Data do pedido de negociação",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div>
                        {new Date(row.DT_PEDIDO_NEGOCIACAO).toLocaleString()}
                    </div>
                </div>
            ),
        },
    ];

    function CorDaAnalise(row: IRenegociacoesAnalise) {
        if (row.DS_STATUS === "REPROVADO") {
            return "red";
        } else if (row.DS_STATUS === "APROVADO") {
            return "green";
        } else if (row.DS_STATUS === "AGUARDANDO APROVAÇÃO") {
            return "blue";
        }
    }

    return (
        <>
            <div className="card card-custom p-10">
                <h4 className="mb-5">Análise de Renegociações</h4>
                <Table
                    keyField="ID_CASO"
                    columns={tableViewColumns}
                    wrapperClasses="mw-100 custom-scroll"
                    tableView={{
                        columns: tableViewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    remote={{ pagination: true }}
                    data={lstRenegociacoes || []}
                    loading={lstRenegociacoesLoading}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    totalPages={totalPaginas}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma análise de Renegociação encontrada
                        </div>
                    )}
                    rowStyle={{ height: 80 }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    rowClasses={"rowClasses"}
                />
            </div>
            <FiltroAprovacaoRenegociacao
                FILTRO_GESTAO_APROVACAO_RENEGOCIACAO={
                    FILTRO_GESTAO_APROVACAO_RENEGOCIACAO
                }
                filter={filter}
                filtroInicial={filtroInicial}
                handleDateChange={handleDateChange}
                setFilter={setFilter}
            />

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}
